const streets = [
  "ул. Абрикосовая",
  "ул. Авакяна",
  "ул. Авангардная",
  "пер. Авангардный",
  "ул. Авиации",
  "пер. Авиационный",
  "ул. Авроровская",
  "ул. Автодоровская",
  "пер. Автодоровский",
  "ул. Автозаводская",
  "пер. Автозаводской",
  "ул. Автомобилистов",
  "пер. Агатовый",
  "ул. Азгура",
  "ул. Азизова",
  "ул. Азовская",
  "ул. Айвазовского",
  "пер. Айвазовского",
  "ул. Академическая",
  "ул. Алибегова",
  "ул. Аллейная",
  "ул. Алтайская",
  "пер. Алтайский",
  "ул. Амбулаторная",
  "пер. Амбулаторный",
  "ул. Амураторская",
  "ул. Амурская",
  "пер. Амурский",
  "ул. Ангарская",
  "ул. Ангарская 2-я",
  "пер. Ангарский",
  "ул. Андреевская",
  "ул. Аннаева",
  "пер. Аннаева",
  "ул. Антоновская",
  "ул. Аполинарьевская",
  "ул. Аранская",
  "пер. Аранский",
  "ул. Арктическая 1-я",
  "ул. Арктическая 2-я",
  "ул. Артема",
  "пер. Артема 1-й",
  "проезд Артема 1-й",
  "проезд Артема 4-й",
  "ул. Артиллеристов",
  "ул. Асаналиева",
  "пер. Асаналиева",
  "ул. Аэродромная",
  "пер. Аэродромный",
  "ул. Аэрофлотская",
  "пер. Аэрофлотский 1-й",
  "ул. Бабушкина",
  "ул. Багратиона",
  "пер. Багратиона 1-й",
  "пер. Багратиона 2-й",
  "ул. Багряная",
  "пер. Багряный",
  "ул. Базисная 1-я",
  "ул. Базисная 2-я",
  "пер. Базисный",
  "ул. Байкальская",
  "ул. Бакинская",
  "ул. Балтийская",
  "ул. Барановщина",
  "пер. Барановщина 1-й",
  "ул. Басиаловская",
  "пер. Басиаловский 1-й",
  "пер. Басиаловский 2-й",
  "ул. Алеся Бачило",
  "пл. Бангалор",
  "ул. Беды",
  "ул. Белинского",
  "ул. Бельского",
  "ул. Беломорская",
  "пер. Беломорский",
  "ул. Белорусская",
  "пер. Белорусский 1-й",
  "пер. Белорусский 2-й",
  "пер. Белорусский 4-й",
  "ул. Березинская",
  "ул. Берестянская",
  "ул. Берсона",
  "пер. Берсона",
  "проезд Бетонный",
  "ул. Бехтерева",
  "ул. Берута",
  "ул. Белецкого",
  "пер. Бехтерева",
  "ул. Библиотечная",
  "ул. Бирюзова",
  "ул. Бобруйская",
  "ул. Богдана Хмельницкого",
  "пер. Богдановича",
  "ул. Богдановича",
  "ул. Болотникова",
  "пер. Болотникова",
  "пер. Больничный",
  "ул. Бородинская",
  "ул. Ботаническая",
  "ул. Болотная",
  "пер. Болотный",
  "ул. Боровая",
  "ул. Брагинская",
  "пер. Брагинский 1-й",
  "пер. Брагинский 2-й",
  "пер. Братский",
  "ул. Брестская",
  "пер. Брестский 1-й",
  "пер. Брестский 2-й",
  "пер. Брестский 3-й",
  "пер. Брестский 4-й",
  "пер. Брестский 5-й",
  "ул. Брилевская",
  "пер. Брилевский 1-й",
  "ул. Петруся Бровки",
  "пер. Броневой",
  "Брилевский тупик",
  "ул. Брест-Литовская",
  "ул. Буденного",
  "ул. Бумажкова",
  "пер. Бумажкова",
  "проезд Бумажкова",
  "ул. Бурдейного",
  "ул. Буйло",
  "ул. Быховская",
  "Ванеева площадь",
  "ул. Змитрока Бядули",
  "ул. Вавилова",
  "пер. Вавилова",
  "ул. Ванеева",
  "ул. Варвашени",
  "ул. Васнецова",
  "пер. Васнецова 1-й",
  "пер. Васнецова 2-й",
  "ул. Ватутина",
  "проезд Ватутина",
  "ул. Ваупшасова",
  "ул. Васильковая",
  "ул. Велозаводская",
  "ул. Великоморская",
  "пер. Великоморский",
  "пер. Велосипедный",
  "пер. Велосипедный 2-й",
  "ул. Верещагина",
  "ул. Верхняя",
  "пер. Верхний",
  "ул. Веснинка",
  "пер. Веснинка",
  "проезд Веснинка",
  "проезд Веснина",
  "ул. Весенняя",
  "ул. Татарская",
  "ул. Вильямса",
  "пер. Вильямса 1-й",
  "ул. Вирская",
  "ул. Витебская",
  "ул. Водозаборная",
  "пер. Вишневый",
  "пер. Водопроводный",
  "пер. Войсковый",
  "ул. Вокзальная",
  "пер. Вокзальный 1-й",
  "ул. Волгоградская",
  "ул. Волгодонская",
  "ул. Волжская",
  "проезд Волжский",
  "ул. Володарского",
  "ул. Волочаевская",
  "пер. Восточный",
  "ул. Вилковщина",
  "пер. Волочаевский 3-й",
  "проезд Волочаевский",
  "ул. Волоха",
  "ул. Воронянского",
  "пер. Воронянского",
  "ул. Восточная",
  "ул. Володько",
  "ул. Встречная",
  "пер. Встречный",
  "пер. Вузовский",
  "ул. Вышелесского",
  "ул. Германовская 2-я",
  "пер. Германовский 2-й",
  "ул. Высокая",
  "пер. Высокий",
  "пер. Вышелесского",
  "ул. Вышелесского",
  "ул. Гагарина",
  "ул. Гало",
  "ул. Гамарника",
  "ул. Гашкевича",
  "ул. Гастелло",
  "ул. Гая",
  "ул. Гвардейская",
  "пер. Гвардейский",
  "ул. Герасименко",
  "пер. Германовский",
  "ул. Герцена",
  "ул. Геологическая",
  "пер. Геологический",
  "ул. Героев 120 дивизии",
  "ул. Гикало",
  "ул. Гинтовта",
  "ул. Глаголева",
  "пер. Глаголева 2-й",
  "пер. Глаголева 3-й",
  "ул. Петра Глебки",
  "проезд Глинище",
  "ул. Гоголевская",
  "ул. Голодеда",
  "проезд Голодеда",
  "ул. Голубева",
  "ул. Голубка",
  "пер. Гомельский",
  "пер. Горный",
  "ул. Богдановича",
  "ул. Горовца",
  "ул. Городецкая",
  "ул. Горная",
  "ул. Горбатова",
  "ул. Горецкого",
  "ул. Гребельки",
  "ул. Грекова",
  "пер. Грекова 1-й",
  "пер. Грекова 2-й",
  "ул. Грибоедова",
  "пер. Грибной",
  "ул. Грицевца",
  "ул. Гродненская",
  "ул. Громова",
  "ул. Грушевская",
  "пер. Грушевский",
  "ул. Гурского",
  "ул. Гусовского",
  "ул. Гуртьева",
  "пер. Дальний",
  "ул. Даумана",
  "пер. Дачный",
  "ул. Дачная",
  "ул. Двинская",
  "ул. Дворищи",
  "ул. Дежнева",
  "ул. Декабристов",
  "ул. Денисовская",
  "пер. Денисовский",
  "просп. Дзержинского просп.",
  "пер. Деповский",
  "пер. Детский 1-й",
  "пер. Детский 2-й",
  "пер. Детский 3-й",
  "ул. Детдомовская",
  "пер. Димитрова",
  "ул. Димитрова",
  "ул. Днепровская",
  "пер. Днепровский",
  "проезд Днепровский",
  "пер. Добромысленский",
  "ул. Доватора",
  "ул. Докучаева",
  "пер. Долгиновский 2-й",
  "пер. Долгиновский 3-й",
  "пер. Долгиновский 4-й",
  "проезд Долгиновский",
  "ул. Домашевская",
  "пер. Домашевский 4-й",
  "ул. Домейко",
  "ул. Дорошевича",
  "ул. Достоевского",
  "пер. Достоевского",
  "пер. Домашевский",
  "Долгиновский тракт",
  "ул. Долгобродская",
  "ул. Дружная",
  "ул. Дражня",
  "пер. Дражненский 1-й",
  "пер. Дражненский 2-й",
  "ул. Дрозда",
  "ул. Дружба",
  "ул. Дубравинская",
  "пер. Дубравинский",
  "ул. Дунина-Марцинкевича",
  "ул. Енисейская",
  "пер. Енисейский 1-й",
  "пер. Енисейский 2-й",
  "проезд Енисейский",
  "ул. Есенина",
  "ул. Жилуновича",
  "ул. Железнодорожная",
  "пер. Железнодорожный 1-й",
  "пер. Железнодорожный 2-й",
  "пер. Железнодорожный 3-й",
  "пер. Железнодорожный 4-й",
  "пер. Железнодорожный 5-й",
  "пер. Железнодорожный 6-й",
  "пер. Железнодорожный 7-й",
  "пер. Железнодорожный 8-й",
  "ул. Жлобинская",
  "ул. Купревича",
  "ул. Жудро",
  "просп. Жукова просп.",
  "ул. Жуковского",
  "пер. Жуковского 1-й",
  "пер. Жуковского 2-й",
  "ул. Заводская",
  "пер. Загородный 1-й",
  "пер. Загородный 2-й",
  "пер. Загородный 3-й",
  "пер. Загородный 4-й",
  "ул. Заливная",
  "ул. Замковая",
  "ул. Западная",
  "ул. Запорожская",
  "пер. Запорожский 1-й",
  "ул. Заречная",
  "пер. Заречный 1-й",
  "пер. Заречный 2-й",
  "пер. Заречный 3-й",
  "Заречный тупик",
  "пер. Запорожский 3-й",
  "ул. Заслонова",
  "ул. Захарова",
  "ул. Заславская",
  "ул. Золотая Горка",
  "ул. Зеленая",
  "пер. Зеленый",
  "ул. Землемерная 1-я",
  "ул. Землемерная 2-я",
  "пер. Землемерный",
  "ул. Земледельческая",
  "пер. Земледельческий 1-й",
  "пер. Земледельческий 3-й",
  "пер. Зенитный",
  "ул. Затишье",
  "ул. Зимняя",
  "пер. Зимний 1-й",
  "пер. Зимний 2-й",
  "ул. Зубачева",
  "пер. Зубачева 1-й",
  "пер. Зубачева 2-й",
  "пер. Зубачева 3-й",
  "Игуменский тракт",
  "ул. Иерусалимская",
  "ул. Ивановская",
  "Известия газеты просп",
  "ул. Извозная",
  "пер. Извозный 1-й",
  "пер. Извозный 2-й",
  "пер. Извозный 3-й",
  "ул. Измайловская",
  "пер. Измайловский 1-й",
  "пер. Измайловский 2-й",
  "пер. Измайловский 3-й",
  "пер. Измайловский 4-й",
  "проезд Измайловский",
  "ул. Илимская",
  "ул. Ильменская",
  "ул. Индустриальная",
  "ул. Инженерная",
  "пер. Инструментальный",
  "ул. Интернациональная",
  "ул. Иркутская",
  "пер. Иркутский",
  "ул. Искалиева",
  "ул. Кабушкина",
  "пер. Казарменный",
  "ул. Казея",
  "пл. Калинина",
  "ул. Калинина",
  "пер. Калинина",
  "пер. Калининградский",
  "ул. Калиновского",
  "проезд Кальварийский",
  "Казинца площадь",
  "пер. Канатный",
  "ул. Карастояновой",
  "ул. Карбышева",
  "ул. Карпова",
  "ул. Каховская",
  "пер. Каховский",
  "ул. Кедышко",
  "ул. Кирилла и Мефодия",
  "ул. Киевская",
  "ул. Кижеватова",
  "ул. Кирова",
  "ул. Киселева",
  "ул. Клецкая",
  "проезд Клецкий",
  "проезд Клубный",
  "ул. Клумова",
  "пер. Клумова",
  "ул. Ключевая",
  "ул. Кнорина",
  "Коммунальная набережная",
  "ул. Ковалева",
  "ул. Ковалевской",
  "пер. Ковалевской",
  "ул. Колесникова",
  "ул. Колхозная",
  "ул. Коллекторная",
  "пер. Коллективный",
  "проезд Коллективный",
  "ул. Заборского",
  "ул. Дроздовича",
  "ул. Коммунистическая",
  "пер. Кооперативный",
  "ул. Комсомольская",
  "ул. Кобринская",
  "ул. Козлова",
  "пер. Козлова",
  "ул. Казинца",
  "пер. Кольцова 1-й",
  "пер. Кольцова 2-й",
  "пер. Кольцова 3-й",
  "пер. Кольцова 4-й",
  "проезд Кольцова",
  "ул. Кольцевая 1-я",
  "ул. Кольцевая 2-я",
  "проезд Кольцевой 1-й",
  "проезд Кольцевой 2-й",
  "ул. Коласа",
  "пер. Коласа",
  "ул. Копыльская",
  "проезд Копыльский",
  "Копыльский тупик",
  "ул. Коржа",
  "ул. Корш-Саблина",
  "ул. Корженевского",
  "пер. Корженевского",
  "ул. Корзюки",
  "ул. Корицкого",
  "пер. Короткий 1-й",
  "пер. Короткий 2-й",
  "пер. Короткий 3-й",
  "ул. Короткевича",
  "ул. Короленко",
  "Комаровское кольцо",
  "ул. Космодемьянской",
  "ул. Космонавтов",
  "ул. Котовского",
  "проезд Котовского",
  "ул. Кошевого",
  "ул. Кольцова",
  "ул. Козыревская",
  "ул. Крапивы",
  "ул. Кропоткина",
  "пер. Кропоткина 1-й",
  "пер. Кропоткина 2-й",
  "ул. Красивая",
  "пер. Красивый",
  "ул. Красная",
  "ул. Красная слобода",
  "ул. Краснослободская",
  "ул. Краснозвездная",
  "пер. Краснозвездный",
  "ул. Красноармейская",
  "пер. Красномысленский",
  "ул. Крайняя",
  "ул. Крамского",
  "пер. Круглый",
  "ул. Крупской",
  "ул. Крупцы",
  "ул. Крыловича",
  "пер. Крыловича 1-й",
  "пер. Крыловича 2-й",
  "ул. Кривая",
  "ул. Кубанская",
  "ул. Кузнечная",
  "проезд Кузнечный",
  "ул. Куйбышева",
  "ул. Кулешова",
  "ул. Кулибина",
  "ул. Кульман",
  "ул. Янки Купалы",
  "ул. Куприянова",
  "ул. Кутузова",
  "ул. Короля",
  "ул. Курчатова",
  "ул. Кунцевщина",
  "ул. Курганная",
  "пер. Кэчевский",
  "ул. Лазарева",
  "ул. Лазо",
  "пер. Лазо",
  "ул. Ландера",
  "Логойский тракт",
  "ул. Левкова",
  "ул. Ленина",
  "ул. Ленинградская",
  "ул. Лермонтова",
  "ул. Лесная",
  "ул. Летняя",
  "пер. Летний 1-й",
  "пер. Летний 2-й",
  "ул. Лещинского",
  "ул. Либаво-Роменская",
  "пер. Линейный",
  "ул. Либкнехта",
  "ул. Литературная",
  "пер. Литературный",
  "ул. Лодочная",
  "пер. Лодочный",
  "ул. Ломоносова",
  "пер. Ломоносова",
  "ул. Лошица 2-ая",
  "ул. Ложинская",
  "ул. Лобанка",
  "проезд Лошицкий",
  "ул. Луговая",
  "пер. Луговой",
  "Мулявина бульвар",
  "ул. Лошицкая",
  "пер. Лошицкий",
  "ул. Лынькова",
  "ул. Лучины",
  "просп. Любимова просп.",
  "ул. Розы Люксембург",
  "пер. Розы Люксембург 2-й",
  "ул. Любанская",
  "пер. Майкова",
  "ул. Магистральная",
  "ул. Мавра",
  "ул. Магнитная",
  "пер. Магнитный",
  "ул. Магазинная",
  "ул. Малая",
  "пер. Малый",
  "пер. Малый 2-й",
  "ул. Малинина",
  "ул. Маневича",
  "ул. Малявки",
  "ул. Марата",
  "ул. Марьевская",
  "8-га сакавіка 8-го марта",
  "ул. Матвеевская",
  "пер. Матвеевский",
  "ул. Матросова",
  "ул. Матусевича",
  "ул. Машинистов",
  "ул. Маяковского",
  "ул. Маркса",
  "пер. Маяковского",
  "просп. Машерова просп.",
  "пер. Машинистов",
  "ул. Макаенка",
  "ул. Машиностроителей",
  "ул. Макаренко",
  "пер. Мебельный",
  "ул. Медвежино",
  "пер. Медвежино",
  "ул. Мележа",
  "ул. Мелиоративная",
  "пер. Мелиоративный",
  "пер. Мельничный 1-й",
  "ул. Мельникайте",
  "ул. Менделеева",
  "пер. Менделеева 1-й",
  "Меньковский тракт",
  "пер. Металлистов 1-й",
  "проезд Металлистов",
  "ул. Мержинского",
  "ул. Мазурова",
  "ул. Минина",
  "пер. Минина",
  "ул. Мирная",
  "ул. Мирошниченко",
  "ул. Мичурина",
  "ул. Михайлова",
  "пер. Михайловский",
  "ул. Михалово",
  "пер. Михалово 1-й",
  "пер. Михалово 2-й",
  "пер. Михалово 3-й",
  "пер. Михалово 4-й",
  "ул. Могилевская",
  "пер. Могилевский",
  "ул. Можайская",
  "пер. Можайский 1-й",
  "пер. Можайский 2-й",
  "ул. Мозырская",
  "пер. Мозырский",
  "проезд Мозырский",
  "пер. Молочный",
  "пер. Можайский 3-й",
  "ул. Мопра",
  "ул. Москвина",
  "пер. Москвина",
  "ул. Московская",
  "пер. Музыкальный",
  "ул. Мядельская",
  "ул. Мясникова",
  "пл. Мясникова",
  "ул. Нагорная",
  "пер. Нагорный",
  "ул. Надеждинская",
  "ул. Наклонная",
  "пер. Наклонный 1-й",
  "пер. Наклонный 2-й",
  "ул. Наполеона Орды",
  "ул. Народная",
  "ул. Натуралистов",
  "ул. Нахимова",
  "пер. Невский",
  "ул. Неждановой",
  "пер. Неждановой",
  "пл. Независимости",
  "просп. Независимости",
  "ул. Некрасова",
  "пер. Некрасова",
  "ул. Немига",
  "ул. Несвижская",
  "ул. Нестерова",
  "пер. Нестерова 1-й",
  "пер. Нестерова 2-й",
  "ул. Нефтяная",
  "пер. Нефтяной",
  "ул. Нарочанская",
  "ул. Никитина",
  "пер. Никитина 1-й",
  "пер. Никитина 2-й",
  "ул. Никифорова",
  "ул. Новаторская",
  "пер. Новаторский",
  "проезд Новаторский",
  "ул. Новая",
  "ул. Новгородская",
  "пер. Новгородский",
  "ул. Нововиленская",
  "пер. Нововиленский",
  "ул. Набережная",
  "ул. Новосельская",
  "пер. Новосельский",
  "ул. Новоуфимская",
  "проезд Новоуфимский",
  "ул. Ногина",
  "Богушевича площадь",
  "ул. Обойная",
  "пер. Обойный",
  "пер. Обувной",
  "ул. Обуховская",
  "пер. Обуховский 1-й",
  "пер. Обуховский 3-й",
  "пер. Обуховский 4-й",
  "Объединенных наций пл.",
  "ул. Огарева",
  "ул. Одесская",
  "пер. Одесский",
  "ул. Одинцова",
  "ул. Одоевского",
  "пер. Одоевского",
  "ул. Озерная",
  "пер. Озерный",
  "Озерцовский тракт",
  "ул. Окрестина",
  "пер. Окрестина 1-й",
  "проезд Окружной",
  "пл. Октябрьская",
  "ул. Октябрьская",
  "ул. Ольшевского",
  "ул. Олешева",
  "пер. Ольшевского",
  "ул. Омельянюка",
  "ул. Кальварийская",
  "ул. Оранжерейная",
  "пер. Орловский 3-й",
  "пер. Орловский 4-й",
  "пер. Орловский 5-й",
  "пер. Орловский 6-й",
  "пер. Орловский 7-й",
  "пер. Орловский 8-й",
  "ул. Орджоникидзе",
  "ул. Оршанская",
  "проезд Оршанский",
  "ул. Орловская",
  "ул. Освобождения",
  "ул. Осенняя",
  "пер. Осенний 1-й",
  "пер. Осенний 2-й",
  "ул. Осипенко",
  "ул. Осиповичская",
  "ул. Раковская",
  "ул. Острошицкая",
  "ул. Основателей",
  "ул. Охотская",
  "пер. Охотский",
  "проезд Охотский",
  "ул. Павлова",
  "пер. Павлова",
  "ул. Панфилова",
  "ул. Папанина",
  "ул. Парашютистов",
  "Парижской коммуны площадь",
  "ул. Парковая",
  "пер. Парниковый 2-й",
  "ул. Парниковая",
  "проезд Парниковый",
  "пер. Парниковый 3-й",
  "пер. Паровозный",
  "просп. Партизанский просп.",
  "ул. Партизанская",
  "ул. Пархоменко",
  "ул. Пашкевич",
  "ул. Пензенская",
  "ул. Первомайская",
  "ул. Передовая",
  "пер. Передовой",
  "ул. Перекопская",
  "ул. Переходная",
  "пер. Переходный 1-й",
  "пер. Переходный 2-й",
  "ул. Пермская",
  "пер. Пермский",
  "ул. Песочная 2-я",
  "ул. Петровщина",
  "пер. Петровщина",
  "ул. Пилотская",
  "ул. Пинская",
  "ул. Пионерская",
  "ул. Пирогова",
  "пер. Пирогова 1-й",
  "пер. Пирогова 2-й",
  "ул. Планерная",
  "ул. Платонова",
  "ул. Плеханова",
  "ул. Подлесная",
  "ул. Подгорная",
  "пл. Победы",
  "ул. 50 лет Победы",
  "просп. Победителей",
  "ул. Подольская",
  "пер. Подольский 1-й",
  "пер. Подольский 2-й",
  "пер. Подольский 3-й",
  "пер. Подольский 4-й",
  "ул. Попова",
  "пер. Кулешова 1-й",
  "пер. Кулешова 2-й",
  "проезд Подшипниковый",
  "ул. Пономарева",
  "ул. Пожарная",
  "ул. Пожарского",
  "ул. Полевая",
  "пер. Полевой",
  "ул. Полесская",
  "пер. Ползунова",
  "ул. Полиграфическая",
  "пер. Полиграфический 1-й",
  "пер. Полиграфический 2-й",
  "пер. Полиграфический 3-й",
  "пер. Полиграфический 4-й",
  "пер. Полоцкий",
  "ул. Полтавская",
  "ул. Поселковая 1-я",
  "ул. Поселковая 2-я",
  "ул. Лукьяновича",
  "пер. Поселковый",
  "пер. Поселковый 2-й",
  "пер. Поселковый 3-й",
  "ул. Полярная",
  "ул. Пономаренко",
  "просп. Правда газеты просп.",
  "ул. Пржевальского",
  "ул. Пржевальского 2-я",
  "Привокзальная",
  "ул. Пригородная",
  "ул. Прилукская",
  "ул. Привлекательная",
  "пер. Прилукский 2-й",
  "ул. Притыцкого",
  "ул. Прогрессивная",
  "пер. Проездной",
  "ул. Приозерная",
  "ул. Прямая",
  "пер. Промышленный",
  "ул. Промышленная",
  "ул. Псковская",
  "ул. Почтовая",
  "ул. Прушинских",
  "ул. Пугачевская",
  "ул. Пулихова",
  "ул. Путейская",
  "пер. Путейский",
  "пер. Путепроводный 1-й",
  "пер. Путепроводный 2-й",
  "пер. Путепроводный 3-й",
  "пер. Путепроводный 4-й",
  "пер. Путепроводный 5-й",
  "пер. Путепроводный 6-й",
  "пер. Путепроводный 7-й",
  "пер. Путепроводный 8-й",
  "ул. Пуховичская",
  "просп. Пушкина просп.",
  "ул. Путилова",
  "ул. Рабкоровская",
  "пер. Рабкоровский",
  "пер. Рабочий",
  "ул. Радиальная",
  "ул. Радиаторная 1-я",
  "пер. Радиаторный 1-й",
  "пер. Радиаторный 2-й",
  "пер. Радиаторный 3-й",
  "пер. Радиаторный 4-й",
  "пер. Радиаторный 5-й",
  "ул. Радиаторная 2-я",
  "ул. Радищева",
  "ул. Радошковичская",
  "ул. Разинская",
  "пер. Разинский",
  "ул. Рафиева",
  "ул. Райниса",
  "ул. Радужная",
  "ул. Революционная",
  "ул. Репина",
  "ул. Романовская Слобода",
  "ул. Рижская",
  "пер. Рижский 1-й",
  "пер. Рижский 2-й",
  "ул. Родниковая",
  "ул. Ротмистрова",
  "пер. Рогачевский",
  "проезд Рогачевский",
  "просп. Рокоссовского просп.",
  "ул. Роменская",
  "ул. Русановича",
  "ул. Руссиянова",
  "ул. Румянцева",
  "ул. Рыбалко",
  "ул. Рылеева",
  "ул. Рущица",
  "ул. Садовая",
  "пер. Самарский",
  "ул. Саперов",
  "ул. Свердлова",
  "ул. Светлая",
  "пер. Свирский 1-й",
  "пер. Свирский 2-й",
  "пер. Свирский 3-й",
  "пер. Свирский 4-й",
  "ул. Свислочская",
  "ул. Свободы",
  "пл. Свободы площадь",
  "ул. Севастопольская",
  "пер. Севастопольский",
  "пер. Северный",
  "ул. Седова",
  "ул. Седых",
  "ул. Селицкого",
  "ул. Семашко",
  "ул. Семенова",
  "ул. Сенницкая",
  "проезд Сенницкий",
  "ул. 3 сентября",
  "ул. Серафимовича",
  "ул. Сердича",
  "ул. Серебрянская",
  "пер. Серебрянский",
  "ул. Серова",
  "ул. Сеченова",
  "пер. Силикатный 1-й",
  "пер. Силикатный 2-й",
  "ул. Сиреневая",
  "ул. Скорины",
  "пер. Скорины 1-й",
  "ул. Скрипникова",
  "ул. Скрыганова",
  "ул. Славинского",
  "пер. Славный",
  "ул. Славянская",
  "ул. Большая Слепня",
  "пер. Слепнянский 2-й",
  "пер. Слепнянский 4-й",
  "ул. Слесарная",
  "пер. Слободской",
  "ул. Слонимская",
  "пер. Слонимский 1-й",
  "ул. Слуцкой",
  "ул. Слободская",
  "проезд Слободской",
  "ул. Смирнова",
  "ул. Смоленская",
  "ул. Смолячкова",
  "Сморговский тракт",
  "пер. Сморговский 1-й",
  "пер. Сморговский 2-й",
  "пер. Сморговский 3-й",
  "пер. Сморговский 4-й",
  "пер. Сморговский 5-й",
  "проезд Сморговский",
  "пер. Снежный",
  "ул. Собинова",
  "пер. Собинова 2-й",
  "ул. Советская",
  "пер. Соколянский",
  "ул. Сосновая",
  "ул. Солнечная",
  "пер. Собинова",
  "ул. Соломенная",
  "ул. Солтыса",
  "пер. Солтыса",
  "ул. Социалистическая",
  "ул. Стариновская",
  "ул. Стадионная",
  "ул. Степянская",
  "пер. Степянский",
  "ул. Станиславского",
  "ул. Старобинская",
  "Староборисовский тракт",
  "ул. Старовиленская",
  "Старовиленский тракт",
  "ул. Сторожевская",
  "ул. Стасова",
  "пер. Стасова 1-й",
  "пер. Стасова 2-й",
  "пер. Стасова 3-й",
  "ул. Стахановская",
  "пер. Стахановский",
  "ул. Стебенева",
  "пер. Стебенева",
  "пер. Стекольный",
  "пер. Степной",
  "ул. Столбцовская",
  "ул. Столетова",
  "пер. Столетова",
  "проезд Столетова",
  "ул. Стрелковая",
  "ул. Строителей",
  "ул. Студенческая",
  "пер. Студенческий",
  "ул. Малое Стиклево",
  "ул. Степная",
  "ул. Суворова",
  "ул. Судмалиса",
  "ул. Суражская",
  "ул. Сурганова",
  "ул. Сурикова",
  "пер. Сурикова",
  "проезд Сурикова",
  "ул. Сухая",
  "ул. Чайлытко",
  "ул. Сухаревская",
  "пер. Тобольский",
  "ул. Таежная",
  "ул. Талаша",
  "пер. Талаша",
  "ул. Таллиннская",
  "пер. Таллиннский",
  "ул. Танка",
  "ул. Тарашкевича",
  "ул. Тарханова",
  "ул. Ташкентская",
  "проезд Ташкентский",
  "ул. Тбилисская",
  "пер. Твердый 1-й",
  "пер. Телеграфный",
  "ул. Тенистая",
  "ул. Тепличная",
  "пер. Тепличный",
  "ул. Тикоцкого",
  "проезд Типографский",
  "пер. Тимирязева",
  "ул. Тимирязева",
  "ул. Тимошенко",
  "ул. Тиражная",
  "пер. Тиражный 1-й",
  "пер. Тиражный 2-й",
  "проезд Тиражный",
  "ул. Тихая",
  "пер. Тихий",
  "пер. Товарищеский",
  "ул. Толбухина",
  "ул. Толстого",
  "пер. Толстого",
  "проезд Толстого",
  "ул. Томская",
  "пер. Томский",
  "ул. Топографическая",
  "пер. Топографический 1-й",
  "пер. Топографический 2-й",
  "ул. Торговая",
  "пер. Торфяной",
  "ул. Азгура",
  "Тракторостроителей бульвар",
  "пер. Транспортный",
  "ул. Тростенецкая",
  "пер. Трубный 1-й",
  "пер. Трубный 2-й",
  "пер. Трубный 3-й",
  "ул. Трудовая",
  "ул. Тростенец малый",
  "пер. Тростенец малый",
  "пер. Трубный",
  "ул. Труса",
  "ул. Тульская",
  "пер. Тульский 1-й",
  "пер. Тульский 2-й",
  "ул. Тургенева",
  "ул. Тухачевского",
  "пер. Тучинский",
  "ул. Тупиковая",
  "ул. Тяпинского",
  "ул. Уборевича",
  "проезд Уборевича",
  "ул. Украинская",
  "ул. Украинки",
  "ул. Ульяновская",
  "ул. Уманская",
  "ул. Уманская 1-я",
  "ул. Уральская",
  "пер. Уральский",
  "ул. Городской Вал",
  "ул. Урожайная",
  "ул. Уручская",
  "ул. Уручье",
  "ул. Уфимская",
  "пер. Ученический",
  "ул. Ушакова",
  "пер. Ушакова",
  "ул. Уютная",
  "ул. Фабрициуса",
  "пер. Фабрициуса",
  "ул. Фабричная",
  "пер. Фабричный 1-й",
  "пер. Фабричный 2-й",
  "ул. Фанипольская",
  "пер. Фанипольский",
  "ул. Федорова",
  "ул. Федотова",
  "пер. Федотова",
  "ул. Физкультурная",
  "пер. Физкультурный",
  "пер. Физкультурный 2-й",
  "ул. Филатова",
  "ул. Филимонова",
  "ул. Фогеля",
  "ул. Фомина",
  "пер. Фомина 1-й",
  "пер. Фомина 2-й",
  "ул. Фроликова",
  "пер. Фруктовый",
  "ул. Фрунзе",
  "ул. Фучика",
  "ул. Хабаровская",
  "ул. Халтурина",
  "пер. Халтурина 1-й",
  "пер. Халтурина 2-й",
  "ул. Харьковская",
  "пер. Харьковский 3-й",
  "ул. Хмелевского",
  "ул. Хмельницкого",
  "ул. Холмогорская",
  "пер. Холмогорский 1-й",
  "пер. Холмогорский 2-й",
  "пер. Холмогорский 3-й",
  "пер. Холмогорский 4-й",
  "ул. Хоружей",
  "ул. Центральная",
  "ул. Цеткин",
  "ул. Циолковского",
  "пер. Циолковского 2-й",
  "ул. Цнянская",
  "ул. Чайкиной",
  "ул. Чайковского",
  "пер. Чайковского",
  "проезд Чайковского",
  "ул. Чапаева",
  "ул. Чарота",
  "ул. Чеботарева",
  "ул. Чекалина",
  "проезд Чекалина",
  "ул. Челюскинцев",
  "пер. Челюскинцев 2-й",
  "ул. Червякова",
  "пер. Червякова",
  "ул. Черниговская",
  "пер. Черниговский 1-й",
  "ул. Чернышевского",
  "пер. Чернышевского 1-й",
  "ул. Черняховского",
  "ул. Чехова",
  "ул. Чигладзе",
  "ул. Чижевская",
  "ул. Чичерина",
  "ул. Чижевских",
  "пер. Чижевских",
  "проезд Чижевских",
  "ул. Чкалова",
  "ул. Чорного",
  "пер. Чорного",
  "ул. Шабаны",
  "ул. Шабловского",
  "ул. Шаранговича",
  "ул. Шатько",
  "ул. Шафарнянская",
  "Шевченко бульвар",
  "ул. Шейпичи",
  "ул. 2-я 6-я линия",
  "ул. Шемеша",
  "ул. Ширмы",
  "ул. Широкая",
  "ул. Шишкина",
  "ул. Шпилевского",
  "ул. Школьная",
  "пер. Школьный",
  "ул. Шорная",
  "ул. Шоссейная",
  "ул. Шугаева",
  "ул. Щедрина",
  "пер. Щедрина 1-й",
  "пер. Щедрина 2-й",
  "пер. Щедрина 3-й",
  "ул. Щепкина",
  "ул. Щербакова",
  "пер. Щербакова",
  "ул. Щорса",
  "ул. Щорса 2-я",
  "ул. Щорса 3-я",
  "ул. Щорса 4-я",
  "ул. Щорса 5-я",
  "ул. Щетовка",
  "ул. Экскаваторная",
  "пер. Экскаваторный",
  "ул. Энгельса",
  "проезд Энергетический",
  "ул. Юбилейная",
  "пер. Юбилейный",
  "Юбилейная площадь",
  "ул. Южная",
  "пер. Южный",
  "пер. Южный 1-й",
  "ул. Юношеская",
  "пер. Юношеский 1-й",
  "пер. Юношеский 2-й",
  "ул. Ярковская",
  "ул. Ясная",
  "ул. Яблоневая",
  "пл. Якуба Коласа",
  "ул. Якубова",
  "ул. Якубовского",
  "ул. Янковского",
  "ул. Игнатенко",
  "Кольцевая",
  "ул. Сырокомли",
  "ул. Беляева",
  "ул. Рогачевская",
  "ул. Водолажского",
  "пер. Кабушкина",
  "ул. Связистов",
  "ул. Корвата",
  "ул. Парашютная",
  "ул. Панченко",
  "ул. Краснодонская",
  "проезд Масюковщина",
  "Районная 1-я магистраль",
  "ул. Мачульского",
  "ул. Ельницкая",
  "ул. Профсоюзная",
  "пер. Профсоюзный",
  "проезд Профсоюзный",
  "Пашковичи пос.",
  "Климовичи пос.",
  "ул. Серебрянская малая",
  "пер. Слепнянский 5-й",
  "ул. Выготского",
  "ул. Скалинская",
  "ул. Ярошевичская",
  "пер. Ярошевичский",
  "просп. Олимпийский просп.",
  "ул. Монтажников",
  "Монтажников 1-й пер",
  "Монтажников 2-й пер",
  "Монтажников 3-й пер",
  "Монтажников 4-й пер",
  "ул. Авиации",
  "ул. Барамзиной",
  "ул. Березогорская",
  "ул. Взлетная",
  "ул. Волмянская",
  "ул. Звездная",
  "ул. Киреева",
  "ул. Ромашкина",
  "ул. Рябиновая",
  "ул. Туполева",
  "ул. Красина",
  "ул. Павловского",
  "ул. Новинковская",
  "ул. Каганца",
  "ул. Жасминовая",
  "ул. Буйницкого",
  "пер. Буйницкого",
  "ул. Ваньковича",
  "ул. Брикета",
  "ул. Жебрака",
  "пер. Жебрака",
  "ул. Ивенецкая",
  "ул. Воложинская",
  "ул. Масюковщина",
  "пер. Масюковщина",
  "ул. Ржавецкая",
  "ул. Баторинская",
  "ул. Запрудная",
  "ул. Придорожная",
  "ул. Зацень",
  "ул. Ермака",
  "пер. Ермака",
  "ул. Рябинницкая",
  "ул. Магулянская",
  "ул. Миколаевская",
  "ул. Заречанская",
  "пер. Заречанский",
  "ул. Приветливая",
  "ул. Стефановская",
  "ул. Огородницкая",
  "ул. Ошмянская",
  "пер. Ошмянский",
  "ул. Гольшанская",
  "пер. Гольшанский 1-й",
  "ул. Бровикова",
  "ул. Микулича",
  "ул. Иодковская",
  "пер. Иодковский",
  "Зеленолужская",
  "ул. Хмаринская",
  "ул. Папернянская",
  "пер. Папернянский",
  "ул. Липовая",
  "ул. Сосновый бор",
  "пер. Дубовлянский",
  "ул. Виноградная",
  "ул. Малофеевская",
  "ул. Фольварковая",
  "пер. Фольварковый",
  "ул. Вересковая",
  "ул. Усадебная",
  "пер. Усадебный",
  "ул. Докшицкая",
  "ул. Бельчицкая",
  "ул. Кривичская",
  "пер. Кривичский 2-й",
  "ул. Глубокская",
  "ул. Лепельская",
  "ул. Монюшко",
  "ул. Марусинская",
  "ул. Браславская",
  "ул. Ушачская",
  "пер. Марусинский",
  "пер. Марусинский 1-й",
  "пер. Марусинский 2-й",
  "ул. Янтарная",
  "ул. Ольховая",
  "ул. Ириновская",
  "пер. Ириновский",
  "ул. Александровская",
  "ул. Вязынская",
  "пер. Вязынский 1-й",
  "пер. Вязынский 2-й",
  "ул. Радошковичская",
  "пер. Радошковичский",
  "пер. Гольшанский 2-й",
  "пер. Кривичский 2-й",
  "ул. Шумилинская",
  "пер. Раубичский",
  "пер. Баторинский",
  "пер. Вилейский",
  "ул. Будславская",
  "пер. Будславский",
  "ул. Бегомльская",
  "ул. Россонская",
  "пер. Боровецкий",
  "ул. Раубичская",
  "ул. Поставская",
  "ул. Воропаевская",
  "ул. Друйская",
  "ул. Освейская",
  "ул. Дисенская",
  "ул. Серебряное кольцо",
  "ул. Золотая",
  "пер. Озерный",
  "ул. Речная",
  "пер. Изумрудный",
  "пер. Золотой",
  "пер. Могилевский",
  "ул. Мопра",
  "ул. Павлюка Труса",
  "проезд Новоуфимский",
  "проезд Парниковый",
  "ул. Парашютистов",
  "ул. Циолковского",
  "проезд Толстого",
  "проезд Типографский",
  "ул. Тарашкевича",
  "пер. Слепнянский 4-й",
  "пер. Слонимский 1-й",
  "ул. Станислава Монюшко",
  "пер. Фруктовый",
  "ул. Язепа Дроздовича",
  "пер. Циолковского 2-й",
  "ул. Уручье"
];
export default [...new Set(streets)];